<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基础信息" name="info"/>
      <el-tab-pane label="农龄份额管理" name="age"/>
      <!-- <el-tab-pane label="股份份额管理" name="share"/> -->
    </el-tabs>
    <info-dialog v-if="activeName === 'info'" :infoDetails="infoDetails" InfoType="edit" @closeInfo="closeInfo"/>
    <age-manage
    v-if="activeName === 'age'"
    :farmerNo="farmerNo"
    :farmerName="farmerName"
    :id="lastAgeApplyNo"
    :usedId="ageApplyNo"
    InfoType="details"
    @showUsed="showUsed"
    :isDetail="isDetail"
    />
    <share-manage
    v-if="activeName === 'share'"
    :farmerNo="farmerNo"
    :id="lastStockApplyNo"
    :usedId="stockApplyNo"
    InfoType="details"
    @showUsed="showUsed"/>
    
  </div>
</template>

<script>
import InfoDialog from './infoDialog.vue'
import AgeManage from './ageManage.vue'
import ShareManage from './shareManage.vue'
export default {
  data() {
    return {
      activeName: 'info',
      showUsedData: false,
      isDetail: false
    }
  },
  props: {
    infoDetails: {
      type: Object,
      default: () => {}
    },
    ageApplyNo: {
      type: String,
      default: ''
    },
    lastAgeApplyNo: {
      type: String,
      default: ''
    },
    lastStockApplyNo: {
      type: String,
      default: ''
    },
    stockApplyNo: {
      type: String,
      default: ''
    },
    farmerNo: {
      type: String,
      default: ''
    },
    farmerName: {
      type: String,
      default: ''
    }
  },
  components: {
    InfoDialog,
    AgeManage,
    ShareManage,
  },
  methods: {
    showUsed (data) {
      this.$emit('showUsed', data)
    },
    closeInfo() {
      this.$emit('closeInfo', true)
    },
  },
  mounted() {
      localStorage.setItem('isDetails', 2)
  }
}
</script>
<style lang="scss" scoped>
/deep/ .age-dialog {
  min-width: 950px;
  width: 60%;
}
</style>